import React from 'react';
import { useFormContext } from '../../components/FormContext';
import { buildFullAddress } from '../../components/FormContext';
import { useNavigate } from 'react-router-dom';
import '../../shared-styles.css';

const ReviewSubmitSection = () => {
  const { 
    formData, 
    isSubmitting,
    setSubmitting,
    setSubmitMessage,
    setCurrentStep,
    userType,
  } = useFormContext();

 
   const navigate = useNavigate();
   const handleSectionSelect = (e) => {
    const sectionIndex = parseInt(e.target.value, 10);
    setCurrentStep(sectionIndex);
  };
// Function to prepare files with clean naming and upload to AWS
  const prepareFiles = async () => {
    const fileUrls = {};
    const fileFields = ['photo', 'policeCheck', 'wwcc', 'visaDocument', 'passportDocument'];
    const fileTypes = {
      photo: 'photo',
      policeCheck: 'police',
      wwcc: 'wwcc',
      visaDocument: 'visa',
      passportDocument: 'passport'
    };
    
    // Clean email for filename (remove special chars)
    const cleanFirstName = formData.firstName.replace(/[^a-zA-Z0-9]/g, '');
    const cleanSurname = formData.surname.replace(/[^a-zA-Z0-9]/g, '');
    const cleanDOB = formData.dateOfBirth.replace(/[-/]/g, '');
    const cleanType = formData.workStatus === 'ABN' ? 
      `ABN${formData.abn.replace(/[^0-9]/g, '')}` : 
      'TFN';
    
    // Process each file
    for (const field of fileFields) {
      const file = formData[field];
      
      if (!file || !(file instanceof File) || file.size === 0) {
        continue;
        }
        if (field === 'wwcc' && formData.hasWWCC !== 'Yes') {
          continue;
        }
        
        // Determine file extension
        const extension = file.name.split('.').pop().toLowerCase();
        const fileType = fileTypes[field];
        // Create new filename
        const newFilename = `${cleanFirstName}_${cleanSurname}_${cleanDOB}_${cleanType}_${fileType}.${extension}`;
        
        // Create a new file with the clean name
        const renamedFile = new File([file], newFilename, { type: file.type });
        
        // Create form data for file upload
        const uploadData = new FormData();
        uploadData.append('file', renamedFile);
        
        // Upload to AWS through your backend with better error handling
    try {
      // Set a timeout to prevent hanging uploads
      const uploadPromise = fetch('/api/upload-file', {
        method: 'POST',
        body: uploadData
      });
      
      // Add a timeout to prevent hanging requests
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Upload timed out')), 30000); // 30 seconds timeout
      });
      
      // Race the upload against the timeout
      const uploadResponse = await Promise.race([uploadPromise, timeoutPromise]);
      
      if (!uploadResponse.ok) {
        // Try to get error details from the response
        const errorData = await uploadResponse.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to upload ${fileType} file (Status: ${uploadResponse.status})`);
      }
      
      const uploadResult = await uploadResponse.json();
      
      // Verify we got a valid URL back
      if (!uploadResult.url || typeof uploadResult.url !== 'string') {
        throw new Error(`Invalid URL returned for ${fileType} upload`);
      }
      
      fileUrls[`${field}Url`] = uploadResult.url;
      
      
      
    } catch (error) {
      // More specific error handling with user-friendly messages
      if (error.name === 'AbortError' || error.message.includes('timed out')) {
        setSubmitMessage({ 
          type: 'error', 
          message: `The ${fileType} upload timed out. Please try again with a smaller file or check your connection.` 
        });
      } else if (error.message.includes('network')) {
        setSubmitMessage({ 
          type: 'error', 
          message: `Network error while uploading ${fileType}. Please check your internet connection.` 
        });
      } else {
        setSubmitMessage({ 
          type: 'error', 
          message: `Error uploading ${fileType}: ${error.message}` 
        });
      }
      
      throw error;
    }
  }
  
  return fileUrls;
};

const sendAutomationEmail = async (formDataArray) => {
          try {
              const response = await fetch('/api/react-emails/Submission', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formDataArray)
              });
      
              
              const result = await response.json();
              if (result) {

                alert("Email successfully sent");
              };
            } catch (error) {
            console.error("Error submitting sending email", error);
            alert("There was an error submitting email.");
          }
        };
  // Handle form submission
  const handleSubmit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    
    
    
    setSubmitting(true);
    setSubmitMessage(null);
    
    try {
      // First, prepare the files with proper naming
      const cleanedFiles = await prepareFiles();
      
      // Join the structured address fields into the single "address"
      // string that /api/submit-user expects
      // e.g. "12 Smith Street, Brunswick VIC 3056"
      const address = buildFullAddress(formData);
      
      // Then upload everything together
      const formDataWithUrls = { ...formData, ...cleanedFiles, address };
      
      const response = await fetch('/api/submit-user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataWithUrls)
      });
      
      let userData;
      
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Submission failed');
        } else {
          userData = await response.json(); 
        }
      setSubmitMessage({ type: 'success', message: 'Records saved successfully! Redirecting to your profile...' });
      const formDataArray = [];

        // Map the named keys to their corresponding array positions
        formDataArray[2] = formData.email;
        formDataArray[4] = formData.firstName;
        formDataArray[15] = formData.businessName;
        formDataArray[5] = formData.visaType;
        formDataArray[6] = formData.workStatus;
        formDataArray[34] = "Snl Profile Form";

        // Fill any gaps with null or empty strings if needed
        for (let i = 0; i < 35; i++) {
          if (formDataArray[i] === undefined) {
            formDataArray[i] = null;
          }
        }
      sendAutomationEmail(formDataArray);
      
         
      
      
      
        setTimeout(() => {
          // Ensure userData is what we expect (an array)
          if (!Array.isArray(userData) && userData !== null) {
           
            userData = [userData];
          }
          
          
          navigate('/landingprofile', { state: { userType, data: userData }});
        }, 2000);
      } catch (error) {
        console.error("Form submission error:", error);
        setSubmitMessage({ type: 'error', message: error.message });
        alert(`Error: ${error.message}`);
      } finally {
        setSubmitting(false);
      }
    };


  return (
    <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Review Summary</h4>
       
        <div className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-md">
            <h5 className="font-medium text-gray-800 mb-2">Personal Information</h5>
            <p className="text-gray-600 text-sm">
              Business Name: {formData.businessName || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Legal First and Middle Name: {formData.firstName || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Legal Surname: {formData.surname || 'Not specified'}
            </p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h5 className="font-medium text-gray-800 mb-2">Contact Information</h5>
            <p className="text-gray-600 text-sm">
              Address: {buildFullAddress(formData) || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Email: {formData.email || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Mobile: {formData.mobile || 'Not specified'}
            </p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h5 className="font-medium text-gray-800 mb-2">Documents</h5>
            <p className="text-gray-600 text-sm">
              Photo: {formData.photo ? formData.photo.name : 'Not uploaded'}
            </p>
            <p className="text-gray-600 text-sm">
              Police Check: {formData.policeCheck ? formData.policeCheck.name : 'Not uploaded'}
            </p>
            <p className="text-gray-600 text-sm">
              Police Check Issue Date: {formData.policeCheckIssue || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Working With Children: {formData.hasWWCC || 'Not specified'}
            </p>
            {formData.hasWWCC === 'Yes' && (
              <>
                <p className="text-gray-600 text-sm">
                  WWCC Document: {formData.wwcc ? formData.wwcc.name : 'Not uploaded'}
                </p>
                <p className="text-gray-600 text-sm">
                  WWCC Expiry: {formData.wwccExpiry || 'Not specified'}
                </p>
              </>
            )}
            <p className="text-gray-600 text-sm">
              Visa Document: {formData.visaDocument ? formData.visaDocument.name : 'Not uploaded'}
            </p>
            <p className="text-gray-600 text-sm">
              Passport Document: {formData.passportDocument ? formData.passportDocument.name : 'Not uploaded'}
            </p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h5 className="font-medium text-gray-800 mb-2">Dates</h5>
            <p className="text-gray-600 text-sm">
              Start Work Date: {formData.startWork || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Date of Birth: {formData.dateOfBirth || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Visa Type: {formData.visaType || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Visa Expiry Date: {formData.visaExpiry || 'Not specified'}
            </p>
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h5 className="font-medium text-gray-800 mb-2">Work Status</h5>
            <p className="text-gray-600 text-sm">
              Work Status: {formData.workStatus || 'Not specified'}
            </p>
            {formData.workStatus === 'TFN' && (
              <>
                <p className="text-gray-600 text-sm">
                  TFN Tax Number: {formData.tfnNumber || 'Not specified'}
                </p>
                <p className="text-gray-600 text-sm">
                  Super Fund Name: {formData.superFundName || 'Not specified'}
                </p>
                <p className="text-gray-600 text-sm">
                  Super Fund Account Name: {formData.superFundAccountName || 'Not specified'}
                </p>
                <p className="text-gray-600 text-sm">
                  Membership Number: {formData.membershipNumber || 'Not specified'}
                </p>
              </>
            )}
            {formData.workStatus === 'ABN' && (
              <p className="text-gray-600 text-sm">
                ABN: {formData.abn || 'Not specified'}
              </p>
            )}
          </div>
          
          <div className="bg-gray-50 p-4 rounded-md">
            <h5 className="font-medium text-gray-800 mb-2">Banking Information</h5>
            <p className="text-gray-600 text-sm">
              Bank Account Name: {formData.bankAccountName || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              BSB Number: {formData.bsbNumber || 'Not specified'}
            </p>
            <p className="text-gray-600 text-sm">
              Bank Account Number: {formData.bankAccountNumber || 'Not specified'}
            </p>
          </div>
        </div>
        <div className="form-section grid grid-cols-2 gap-4 pt-4 pb-1" style={{ 
          position: 'sticky', 
          bottom: 0, 
          backgroundColor: 'white',  // Solid background to prevent content showing through
          zIndex: 50,
          
          borderTop: '1px solid #e5e7eb'
        }}>
        <div className="w-full">
          
          
            <select
              id="section-select"
              onChange={handleSectionSelect}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sticky-submit-button text-center"
              
            >
          <option value="">Select a section to edit</option>
          <option value="0">1. Upload Photo</option>
          <option value="1">2. Personal Information</option>
          <option value="2">3. Contact Information</option>
          <option value="3">4. Police Check</option>
          <option value="4">5. Work Dates</option>
          <option value="5">6. Working With Children Check</option>
          <option value="6">7. Visa Information</option>
          <option value="7">8. Documents</option>
          <option value="8">9. Work Status</option>
          <option value="9">10. Banking Information</option>
        </select>
      </div>
        <div className="w-full">
        {/* Submit button */}
        <button
          type="submit"
          id="final-submit-button"
          className="flex-1 sticky-submit-button pulse-attention"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Form'}
        </button>
      </div>
      <div className="col-span-2 ">
          <span className="submit-indicator text-center ">
        Please review all infomation or edit any information above before submitting
          </span>

        </div>
      </div>
      </div>
      
    



    );
};


export default ReviewSubmitSection;